module.exports = __webpack_public_path__ + "resources/users-ec43e9523918d3499cce6e6d757cabb7.svg";